import React from "react";
import { useTranslation } from "react-i18next";
import { isMobile } from "../../../../utils/screenUtil";
import "./DocumentTitle.scss";
import RemoveDocument from "./RemoveDocument";

function DocumentTitle({
  index,
  required,
  link,
  label,
  documents,
  dispatchUpdateAction,
  bulmaTitleSize = 6,
  size = 20,
}) {
  const { t } = useTranslation();

  return (
    <div className={`${required ? "pl-3" : ""} is-size-${bulmaTitleSize} is-inline-flex`}>
      {!required && (
        <RemoveDocument
          index={index}
          documents={documents}
          dispatchUpdateAction={dispatchUpdateAction}
        />
      )}

      <div
        className={
          required && isMobile()
            ? "is-inline-flex"
            : !required && isMobile()
              ? "mt-4 p-1"
              : "is-inline-flex"
        }
      >
        {required && (
          <span className={required ? "has-text-danger is-required-document" : "is-invisible"}>
            *
          </span>
        )}

        <div style={isMobile() ? { display: "inline-block" } : {}} className="pl-1 pr-1">{`${
          index + 1
        }.`}</div>
        {required ? (
          <a
            className="is-link has-text-dark"
            target="_blank"
            rel="noopener noreferrer"
            href={link}
          >
            {label}
          </a>
        ) : (
          <input
            style={isMobile() ? { display: "inline-block" } : {}}
            placeholder={t("requests.submission.upload.enterDocumentsTitle")}
            className={`has-text-dark is-link document-title-input is-size-${bulmaTitleSize}`}
            value={label ? label : ""}
            size={size}
            maxLength={200}
            onChange={(e) => {
              documents[index].label = e.currentTarget.value;
              dispatchUpdateAction();
            }}
          />
        )}
      </div>
    </div>
  );
}

export default DocumentTitle;
